module.exports = "/assets/data/0f242d3d50c890066df1ac76ced22438-SK1.data.json";